export default String.raw`
.pagination {
  display: flex;
  padding: 24px 0;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  align-items: center;
  justify-content: flex-end;
  .change-quantity {
    background: none;
    border: none;
    padding: 0 8px;
    width:auto;
    color: $labelsColor;
    cursor: pointer;

    &__active {
      color: $primaryColorFont !important;
      font-weight: 600;
    }
    
    &-button {
      border: none;
      padding: 0;
      height: 24px;
      display: flex;
      align-items: center;
      background: none;
      color: $iconColors;
      font-weight: 600;
      cursor: pointer;

      @media screen and (max-width: 767px) {
        span {
          display: none;
        }
      }

      &[disabled] {
        color: $labelsColor;
        cursor: default;

        svg {
          fill: $labelsColor;
        }
      }

      svg {
        width: 16px;
        height: 16px;
        fill: $iconColors;

        @media screen and (max-width: 767px) {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
  .page-amount {
    display: block;
    float: left;
  }
  > *:not(:first-child) {
    margin-left: 8px;
  }
}
`